/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Floor = {
    properties: {
        id: {
    type: 'number',
},
        name: {
    type: 'string',
    isRequired: true,
},
        orderRank: {
    type: 'number',
},
    },
};